import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { expand, of, reduce } from 'rxjs';
import { map } from 'rxjs/operators';
import { CountryDTOInterface, CountryInterface } from '../models/country.interface';

@Injectable()
export class CountriesService {
  countriesURl = '/lottos/api/back-office/v1/countries';

  constructor(private httpClient: HttpClient) {}

  getCountriesList(pageNumber = 1, pageSize = 100): Observable<CountryDTOInterface> {
    return this.httpClient.get<CountryDTOInterface>(`${this.countriesURl}`, {
      params: new HttpParams().set('page-number', pageNumber).set('page-size', pageSize),
    });
  }

  getAllCountriesList(): Observable<CountryInterface[]> {
    const pageSize = 100;

    return this.getCountriesList(1, pageSize).pipe(
      expand((response) => {
        if (response.more) {
          return this.getCountriesList(response.pageNumber + 1, pageSize);
        } else {
          return of();
        }
      }),
      map((res) => res.contents),
      reduce((acc, contents) => [...acc, ...contents], [])
    );
  }
}
